import { SplitFactory } from '@splitsoftware/splitio-react'
import React, { useEffect, useMemo } from 'react'
import { I18nextProvider } from 'react-i18next'
import { useRoutes } from 'react-router-dom'
import { getCookie } from 'typescript-cookie'

import i18n from 'Lib/i18n'
import { useUserStore } from 'Stores/userStoreModuleFed'

import { protectedRoutes } from './protected'
import { publicRoutes } from './public'

const AppRoutes = () => {
  const { isLoggedIn, accountId, language } = useUserStore()

  const setLanguage = async () => {
    const languageToSet = getCookie('language') || language
    await i18n.changeLanguage(languageToSet)
  }

  useEffect(() => {
    setLanguage()
      .then(() => {})
      .catch(() => {})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language])

  const splitIoConfig: SplitIO.IBrowserSettings = useMemo(
    () => ({
      core: {
        authorizationKey: process.env.REACT_APP_SPLIT_KEY || '',
        key: accountId ? accountId.toString() : sessionStorage.getItem('my_uuid') || '',
      },
    }),
    [accountId]
  )

  const routes = isLoggedIn ? protectedRoutes : []

  const element = useRoutes([...publicRoutes, ...routes])

  return (
    <SplitFactory config={splitIoConfig}>
      <I18nextProvider i18n={i18n}>{element}</I18nextProvider>
    </SplitFactory>
  )
}

export default AppRoutes
